// @ts-nocheck
/* eslint-disable */
import copy from 'utils/cloneObj';
import {
  ADD_NEW_DAILY_COST_REQUEST,
  ADD_NEW_DAILY_COST_SUCCESS,
  CLEAR_REDUCER,
  COLLAPSE_ALL_ROW_DAILY_COST_HR,
  DELETE_ATTACHED_DOCUMENT_SUCCESS,
  DELETE_COST_TRACKING_NOTE_REQUEST,
  DELETE_COST_TRACKING_NOTE_SUCCESS,
  DELETE_DAILY_COST_REQUEST,
  DELETE_DAILY_COST_SUCCESS,
  EXPAND_ALL_ROW_DAILY_COST_HR,
  EXPAND_ROW_DAILY_COST_HR,
  GET_COST_TRACKING_DATA_REQUEST,
  GET_COST_TRACKING_DATA_SUCCESS,
  GET_COST_TRACKING_HR_DATA_REQUEST,
  GET_COST_TRACKING_HR_DATA_SUCCESS,
  GET_COST_TRACKING_ROW_DATA_SUCCESS,
  GET_DAILY_COST_RESOURCE_LIST_SUCCESS,
  GET_DAILY_COST_SUBTASK_LIST_SUCCESS,
  POST_COST_TRACKING_DATA_SUCCESS,
  POST_COST_TRACKING_DOCUMENT_SUCCESS,
  POST_COST_TRACKING_NOTE_REQUEST,
  POST_COST_TRACKING_NOTE_SUCCESS,
  RESET_EXPANDED_ROW_DAILY_COST_HR,
  SEARCH_DAILY_COST,
  UPDATE_COST_TRACKING_CELL_DATA,
  UPDATE_COST_TRACKING_NOTE_REQUEST,
  UPDATE_COST_TRACKING_NOTE_SUCCESS,
} from '../constants/cost_tracking';

const initialState = {
  mainDailyCosts: [],
  dailyCosts: [],
  dailyCostsHr: [],
  expandedRowHr: {
    tasks: [],
    subTasks: [],
  },
  days: [],
  updatedDailyCostsHr: [],
  addNoteSuccess: false,
  addedNoteDailyCostId: null,
  addedNote: {},
  deleteNoteSuccess: false,
  deletedNoteDailyCostId: null,
  deletedNoteId: null,
  updateNoteSuccess: false,
  updatedNoteDailyCostId: null,
  updatedNoteId: null,
  updatedNote: {},
  addDailyCostSuccess: false,
  deleteDailyCostSuccess: false,
  pagination: {
    totalPages: null,
    total: null,
    perPage: null,
    currentPage: null,
  },
  loading: false,
  hrLoading: false,
};

function costTrackingReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_COST_TRACKING_DATA_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_COST_TRACKING_DATA_SUCCESS: {
      return {
        ...state,
        dailyCosts: [...action.payload.daily_costs],
        mainDailyCosts: [...action.payload.daily_costs],
        pagination: {
          ...state.pagination,
          totalPages: action.payload.total_pages,
          perPage: action.payload.per_page,
          total: action.payload.total,
          currentPage: action.payload.current_page,
        },
        loading: false,
      };
    }

    case GET_DAILY_COST_SUBTASK_LIST_SUCCESS: {
      return getDailyCostSubTaskList(state, action);
    }

    case GET_DAILY_COST_RESOURCE_LIST_SUCCESS: {
      return getDailyCostResourceList(state, action);
    }
    case GET_COST_TRACKING_HR_DATA_REQUEST: {
      return {
        ...state,
        hrLoading: true,
      };
    }

    case GET_COST_TRACKING_HR_DATA_SUCCESS: {
      return {
        ...state,
        dailyCostsHr: [...action.payload.daily_costs],
        days: [...action.payload.config.days],
        pagination: {
          ...state.pagination,
          totalPages: action.payload.total_pages,
          perPage: action.payload.per_page,
          total: action.payload.total,
          currentPage: action.payload.current_page,
        },
        hrLoading: false,
      };
    }

    case GET_COST_TRACKING_ROW_DATA_SUCCESS: {
      return updateRowData(state, action.payload, action.reqPayload);
    }

    case UPDATE_COST_TRACKING_CELL_DATA: {
      return updateCellData(state, action.payload);
    }

    case POST_COST_TRACKING_DATA_SUCCESS: {
      return updateRowData(state, action.payload, action.reqPayload);
    }

    case POST_COST_TRACKING_NOTE_REQUEST: {
      return {
        ...state,
        addNoteSuccess: false,
        addedNoteDailyCostId: null,
        addedNote: {},
      };
    }

    case POST_COST_TRACKING_NOTE_SUCCESS:
      return addNote(state, action.payload, action.reqPayload);

    case DELETE_COST_TRACKING_NOTE_REQUEST:
      return {
        ...state,
        deleteNoteSuccess: false,
        deletedNoteDailyCostId: null,
        deletedNoteId: null,
      };

    case DELETE_COST_TRACKING_NOTE_SUCCESS:
      return deleteNote(state, action.payload);

    case UPDATE_COST_TRACKING_NOTE_REQUEST:
      return {
        ...state,
        updateNoteSuccess: false,
        updatedNoteDailyCostId: null,
        updatedNoteId: null,
        updatedNote: {},
      };

    case UPDATE_COST_TRACKING_NOTE_SUCCESS:
      return updateNote(state, action.payload);

    case ADD_NEW_DAILY_COST_REQUEST:
      return {
        ...state,
        addDailyCostSuccess: false,
      };

    case ADD_NEW_DAILY_COST_SUCCESS:
      return {
        ...state,
        addDailyCostSuccess: true,
      };

    case DELETE_DAILY_COST_REQUEST:
      return {
        ...state,
        deleteDailyCostSuccess: false,
      };

    case DELETE_DAILY_COST_SUCCESS:
      return {
        ...state,
        deleteDailyCostSuccess: true,
      };

    case SEARCH_DAILY_COST:
      return searchData(state, action);

    case EXPAND_ROW_DAILY_COST_HR:
      return expandRow(state, action);

    case EXPAND_ALL_ROW_DAILY_COST_HR:
      return expandAllRow(state);

    case COLLAPSE_ALL_ROW_DAILY_COST_HR:
      return collapseAllRow(state);

    case RESET_EXPANDED_ROW_DAILY_COST_HR:
      return {
        ...state,
        expandedRowHr: {
          tasks: [],
          subTasks: [],
        },
      };

    case POST_COST_TRACKING_DOCUMENT_SUCCESS:
      return addDocuments(state, action.payload, action.payload.dailyCostId);

    case DELETE_ATTACHED_DOCUMENT_SUCCESS:
      return deleteDocuments(state, action.payload);

    case CLEAR_REDUCER:
    return {
    ...state,
      updatedDailyCostsHr: []
    }

    default: {
      return state;
    }
  }
}

const deleteDocuments = (state, ids) => {
  const clonedDailyCosts = [...state.dailyCosts];
  const index = clonedDailyCosts.findIndex(
    (dailyCost) => dailyCost.id === ids.attachementId,
  );
  const selectedDailyCost = clonedDailyCosts.find(
    (dailyCost) => dailyCost.id === ids.attachementId,
  );
  const otherDailyCost = clonedDailyCosts.filter(
    (obj) => obj.id != ids.attachementId,
  );
  let data = [];
  if (selectedDailyCost) {
    const allDocuments = selectedDailyCost?.documents?.filter(
      (obj) => obj.id !== ids.deletedId,
    );
    const finalData = { ...selectedDailyCost, documents: allDocuments };
    data = [...otherDailyCost];
    data.splice(index, 0, finalData);
    return {
      ...state,
      dailyCosts: data,
      mainDailyCosts: data,
    };
  }
};

const addDocuments = (state, action, id) => {
  const clonedDailyCosts = [...state.dailyCosts];
  const index = clonedDailyCosts.findIndex((dailyCost) => dailyCost.id === id);
  const selectedDailyCost = clonedDailyCosts.find(
    (dailyCost) => dailyCost.id === id,
  );
  const otherDailyCost = clonedDailyCosts.filter((obj) => obj.id != id);
  let data = [];
  if (selectedDailyCost) {
    const documents = [...selectedDailyCost.documents, action];
    const updatedDailyCost = { ...selectedDailyCost, documents: documents };
    data = [...otherDailyCost];
    data.splice(index, 0, updatedDailyCost);
    return {
      ...state,
      dailyCosts: data,
      mainDailyCosts: data,
    };
  }
};

const searchData = (state, action) => {
  if (!action.payload) {
    return {
      ...state,
      dailyCosts: [...state.mainDailyCosts],
    };
  }
  return {
    ...state,
    dailyCosts: state.dailyCosts.filter((cost) =>
      cost.resource_name
        .replace(/ /g, '')
        .toUpperCase()
        .includes(action.payload.trim().replace(/ /g, '').toUpperCase()),
    ),
  };
};

const updateCellData = (state, payload) => {
  if (payload.tableType && payload.tableType === 'hr') {
    const maxVal = Math.max(
      ...state.updatedDailyCostsHr
        .map((dailyCost) => dailyCost.uid)
        .filter(Boolean),
      0,
    );

    const clonedDailyCosts = copy(state.dailyCostsHr);
    const selectedTask = clonedDailyCosts.find(
      (task) => task.id === payload.taskId,
    );

    if (selectedTask) {
      const selectedSubTask = selectedTask.sub_task.find(
        (subTask) => subTask.id === payload.subTaskId,
      );

      if (selectedSubTask) {
        const selectedResource = selectedSubTask.resource.find(
          (resrc) => resrc.id === payload.resourceId,
        );

        if (selectedResource[payload.dayId]) {
          selectedResource[payload.dayId].uid = maxVal + 1;
          selectedResource[payload.dayId][payload.field] = payload.value;
        } else {
          selectedResource[payload.dayId] = {
            uid: maxVal + 1,
            [payload.field]: payload.value,
            ...(payload.field !== 'rate' && {
              rate: payload.rate,
            }),
          };
        }
      }
    }

    const updatedDailyCost = {
      uid: maxVal + 1,
      id: payload.dailyCostId,
      resource: payload.resourceId,
      date: payload.dayId,
      rate: payload.field === 'rate' ? payload.value : payload.rate,
      quantity: payload.field === 'quantity' ? payload.value : payload.quantity,
      duration: payload.field === 'duration' ? payload.value : payload.duration ? payload.duration : '0',
      notes: [], // static
    };

    return {
      ...state,
      dailyCostsHr: clonedDailyCosts,
      updatedDailyCostsHr: state.updatedDailyCostsHr
        .filter((dailyCost) => dailyCost.uid !== payload.uid)
        .concat(updatedDailyCost),
    };
  }
  const clonedCostTrackingData = copy(state.dailyCosts);

  const selectedDailyCost = clonedCostTrackingData.find(
    (data) => data.id == payload.id,
  );

  if (payload.field === 'task_id') {
    selectedDailyCost.task = payload.label;
    selectedDailyCost.subTaskList = [];
    selectedDailyCost.resourceList = [];

    selectedDailyCost.sub_task_id = 0;
    selectedDailyCost.sub_task = '';
    selectedDailyCost.resource = 0;
    selectedDailyCost.resource_name = '';
    selectedDailyCost.subTaskLoader = true;
    selectedDailyCost.resourceLoader = false;
    selectedDailyCost.code = '';
    selectedDailyCost.unit = '';
    selectedDailyCost.rate = '';
  }

  if (payload.field === 'sub_task_id') {
    selectedDailyCost.sub_task = payload.label;
    selectedDailyCost.resourceList = [];
    selectedDailyCost.resource = 0;
    selectedDailyCost.resource_name = '';
    selectedDailyCost.subTaskLoader = false;
    selectedDailyCost.resourceLoader = true;
    selectedDailyCost.code = '';
    selectedDailyCost.unit = '';
    selectedDailyCost.rate = '';
  }

  if (payload.field === 'resource') {
    selectedDailyCost.resource_name = payload.label;
    selectedDailyCost.resourceLoader = false;

    const selectedResource = selectedDailyCost.resourceList.find(
      (resrc) => resrc.id === +payload.value,
    );

    if (selectedResource) {
      selectedDailyCost.rate = selectedResource.charge_rate;
      selectedDailyCost.code = selectedResource.code;
      selectedDailyCost.unit = selectedResource.unit;
    }
  }

  selectedDailyCost[payload.field] = payload.value;

  return {
    ...state,
    dailyCosts: clonedCostTrackingData,
  };
};

const updateRowData = (state, payload, reqPayload) => {
  if (reqPayload && reqPayload.taskId) {
    const clonedDailyCosts = copy(state.dailyCostsHr);
    const selectedTask = clonedDailyCosts.find(
      (task) => task.id === reqPayload.taskId,
    );

    if (selectedTask) {
      const selectedSubTask = selectedTask.sub_task.find(
        (subTask) => subTask.id === reqPayload.subTaskId,
      );

      if (selectedSubTask) {
        const selectedResource = selectedSubTask.resource.find(
          (resrc) => resrc.id === reqPayload.resourceId,
        );

        if (selectedResource[reqPayload.dayId]) {
          selectedResource[reqPayload.dayId][reqPayload.field] =
            payload[reqPayload.field];
          if (payload.id) {
            selectedResource[reqPayload.dayId].id = payload.id;
          }
        }
      }
    }

    return {
      ...state,
      dailyCostsHr: clonedDailyCosts,
    };
  }
  const clonedCostTrackingData = copy(state.dailyCosts);

  const selectedResource = clonedCostTrackingData.find(
    (data) => data.id == payload.id,
  );

  selectedResource.quantity = payload.quantity;
  selectedResource.rate = payload.rate;

  return {
    ...state,
    dailyCosts: clonedCostTrackingData,
  };
};

const addNote = (state, payload, reqPayload) => {
  if (reqPayload && reqPayload.taskId) {
    const clonedDailyCosts = copy(state.dailyCostsHr);
    const selectedTask = clonedDailyCosts.find(
      (task) => task.id === reqPayload.taskId,
    );

    if (selectedTask) {
      const selectedSubTask = selectedTask.sub_task.find(
        (subTask) => subTask.id === reqPayload.subTaskId,
      );

      if (selectedSubTask) {
        const selectedResource = selectedSubTask.resource.find(
          (resrc) => resrc.id === reqPayload.resourceId,
        );

        if (selectedResource) {
          if (selectedResource[reqPayload.dayId]) {
            selectedResource[reqPayload.dayId].notes = [
              ...(selectedResource[reqPayload.dayId].notes
                ? selectedResource[reqPayload.dayId].notes
                : []),
              payload,
            ];
          }
        }
      }
    }

    return {
      ...state,
      dailyCostsHr: clonedDailyCosts,
      addNoteSuccess: true,
    };
  }
  const clonedCostTrackingData = copy(state.dailyCosts);
  const selectedResource = clonedCostTrackingData.find(
    (data) => data.id == payload.dailyCostId,
  );

  if (selectedResource) {
    selectedResource.notes = [...selectedResource.notes, payload];
  }

  return {
    ...state,
    dailyCosts: clonedCostTrackingData,
    addNoteSuccess: true,
    addedNoteDailyCostId: payload.dailyCostId,
    addedNote: payload,
  };
};

const updateNote = (state, payload) => {
  const clonedCostTrackingData = copy(state.dailyCosts);
  const selectedResource = clonedCostTrackingData.find(
    (data) => data.id == payload.dailyCostId,
  );

  if (selectedResource) {
    const { dailyCostId, ...rest } = payload;
    selectedResource.notes = selectedResource.notes
      .filter((note) => note.id !== payload.id)
      .concat(rest);
  }

  return {
    ...state,
    dailyCosts: clonedCostTrackingData,
    updateNoteSuccess: true,
    updatedNoteDailyCostId: payload.dailyCostId,
    updatedNoteId: payload.id,
    updatedNote: payload,
  };
};

const deleteNote = (state, payload) => {
  const clonedCostTrackingData = copy(state.dailyCosts);
  const selectedResource = clonedCostTrackingData.find(
    (data) => data.id == payload.dailyCostId,
  );

  if (selectedResource) {
    selectedResource.notes = selectedResource.notes.filter(
      (note) => note.id !== payload.noteId,
    );
  }

  return {
    ...state,
    dailyCosts: clonedCostTrackingData,
    deleteNoteSuccess: true,
    deletedNoteDailyCostId: payload.dailyCostId,
    deletedNoteId: payload.noteId,
  };
};

const getDailyCostSubTaskList = (state, action) => {
  const dailyCosts = [...state.dailyCosts];
  const selectedCost = dailyCosts.find(
    (cost) => cost.id === +action.reqPayload.dailyCostId,
  );

  selectedCost.subTaskList = action.payload.map((subTask) => ({
    value: subTask.id,
    label: subTask.title,
    ...subTask,
  }));

  return {
    ...state,
    dailyCosts,
  };
};

const getDailyCostResourceList = (state, action) => {
  const dailyCosts = [...state.dailyCosts];
  const selectedCost = dailyCosts.find(
    (cost) => cost.id === +action.reqPayload.dailyCostId,
  );

  selectedCost.resourceList = action.payload.map((resrc) => ({
    value: resrc.id,
    label: resrc.name,
    ...resrc,
  }));

  return {
    ...state,
    dailyCosts,
  };
};

const expandRow = (state, action) => {
  const {
    payload: { type, taskId, subTaskId },
  } = action;

  const clonedExpandedRow = copy(state.expandedRowHr);
  if (type === 'task') {
    if (clonedExpandedRow.tasks.find((task) => task.id === taskId)) {
      clonedExpandedRow.tasks = clonedExpandedRow.tasks.filter(
        (task) => task.id !== taskId,
      );
    } else {
      clonedExpandedRow.tasks.push({ id: taskId });
    }
  } else if (
    clonedExpandedRow.subTasks.find((subTask) => subTask.id === subTaskId)
  ) {
    clonedExpandedRow.subTasks = clonedExpandedRow.tasks.filter(
      (subTask) => subTask.id !== subTaskId,
    );
  } else {
    clonedExpandedRow.subTasks.push({ id: subTaskId });
  }

  return {
    ...state,
    expandedRowHr: clonedExpandedRow,
  };
};

const expandAllRow = (state) => {
  const expandedRow = { tasks: [], subTasks: [] };

  expandedRow.tasks = state.dailyCostsHr.map((task) => ({ id: task.id }));

  expandedRow.subTasks = state.dailyCostsHr
    .map((task) => task.sub_task)
    .flat()
    // .reduce((acc, cur) => acc.concat(cur), []);
    .map((subTask) => ({ id: subTask.id }));
  return {
    ...state,
    expandedRowHr: expandedRow,
  };
};

const collapseAllRow = (state) => {
  return {
    ...state,
    expandedRowHr: {
      tasks: [],
      subTasks: [],
    },
  };
};

export default costTrackingReducer;
